/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import $ from '../jquery-wrapper';

Handlebars.registerHelper('xsrfTokenInput', function () {
  return new Handlebars.SafeString(
    '<input type="hidden" class="hide" name="_xsrfToken" ' + 'value="' + $('#_xsrfToken').text() + '">'
  );
});

export default Handlebars;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/courage/src/util/handlebars/helper-xsrfTokenInput.js
// module id = 53
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/handlebars/helper-xsrfTokenInput.js